export default class Accordion {
  /**
   * Accordions
   * .accordion-item#aId*n~>a.accordion-item-title[href='#aId']
   * .accordion-item#aId*n~>a.accordion-item-text
   */
  constructor() {
    document.querySelectorAll('.accordion-item').forEach(elt => {
      elt.querySelector('.accordion-item-title').addEventListener('click', this.showText.bind(this));
    });
    window.addEventListener('load', this.initialize());
    window.addEventListener('custom-resize', this.onResize.bind(this));
  }

  /**
   * Initialize Accordions
   * Works with `W3 Total Cache` plugin lazy images load
   */
  initialize() {
    document.querySelectorAll('.accordion-item').forEach(elt => {
      let loaded = elt.querySelectorAll('img.lazy:not(.loaded)').length <= 0;
      if (!loaded) {
        const interval = setInterval(() => {
          loaded = elt.querySelectorAll('img.lazy:not(.loaded)').length <= 0;
          if (loaded) {
            this.setHeight(elt);
            clearInterval(interval);
          }
        }, 200);
      } else {
        this.setHeight(elt);
      }
    });
  }

  /**
   * Set accordion content height
   * @param {HTMLElement} content
   */
  setHeight(elt) {
    const isActive = elt.getAttribute('data-active') === 'true';
    const content = elt.querySelector('.accordion-item-text');
    content.style.height = 'auto';
    setTimeout(() => {
      const height = Math.round(content.getBoundingClientRect().height);
      content.setAttribute('data-height', height);
      if (!isActive) {
        content.style.height = 0;
      } else {
        content.style.height = `${height}px`;
      }
    }, 100);
  }

  /**
   * Show / hide Accordion text
   * @param {MouseEvent} e
   */
  showText(e) {
    e.preventDefault();
    const parent = document.getElementById(e.currentTarget.hash.substring(1));
    const content = parent.querySelector('.accordion-item-text');
    const isActive = parent.getAttribute('data-active') === 'true';
    if (!isActive) {
      content.style.height = `${content.getAttribute('data-height')}px`;
      setTimeout(() => {
        const offset = document.getElementById('head').getBoundingClientRect().height;
        window.scroll(0, parent.getBoundingClientRect().top + window.pageYOffset - offset);
      }, 500);
    } else {
      content.style.height = 0;
    }
    parent.setAttribute('data-active', isActive ? 'false' : 'true');
  }

  /**
   * window.custom-resize handler
   *
   * @param {CustomEvent} e
   */
  onResize(e) {
    if (e.detail.width) {
      /** Reset */
      this.initialize();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Accordion.js